import { render } from "./SegmentsFunde.vue?vue&type=template&id=bd10d3a6&scoped=true"
import script from "./SegmentsFunde.vue?vue&type=script&lang=js"
export * from "./SegmentsFunde.vue?vue&type=script&lang=js"

import "./SegmentsFunde.vue?vue&type=style&index=0&id=bd10d3a6&scoped=true&lang=css"

import exportComponent from "/builds/dlr-pt/rote-liste-zentrum/prj-moose_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd10d3a6"]])

export default __exports__